/**
 * Created by h3 on 2018-09-13.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite, TweenLite} from "gsap";
import {FruitsGameConfig} from "../../FruitsGameConfig";
import {FruitsGameMode} from "../../gamemode/FruitsGameMode";
import {FruitsParsedGameData} from "../../server/data/FruitsParsedGameData";
import {FruitsParsedInitData} from "../../server/data/FruitsParsedInitData";

export interface IFruitsLogo {
    name:string,
    textureName:string,
    mode:FruitsGameMode,
}

export class LogoAnimationBit extends BaseView {

    private _layer:ScalableLayer;
    private _container:PIXI.Container;
    private _logo:PIXI.Sprite;
    private _currentLogo:IFruitsLogo;
    private _gameMode:string = FruitsGameMode.NORMAL;
    private _orientation:Orientation;
    private _lastMode:string;
    private _nextMode:string;
    private _logos:IFruitsLogo[] = [{name : "normal", textureName : "logo", mode : FruitsGameMode.NORMAL},
        {name : "sticky", textureName : "logoSticky", mode : FruitsGameMode.STICKY_RESPIN},
        {name : "bonus", textureName : "logoBonus", mode : FruitsGameMode.BONUS_GAME}
    ];

    private _initDataReceived:boolean = false;
    private _gfxLoaded:boolean = false;

    constructor() {
        super(ResourcesGroupName.MAIN);
        this._layer = StageManager.getLayer(FruitsGameConfig.instance.LAYERS.LOGO.name);

        this.addEventListeners();
    }


    protected addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onGameData(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameData(event.params[0]));
    }

    protected initAnimations():void {
        this._container = new PIXI.Container();
        this._layer.addChild(this._container);

        this._lastMode = FruitsGameMode.NORMAL;
        this._gfxLoaded = true;
        this.createGraphics();
    }

    protected onResize(resizeData:IResizeData):void {
        this._orientation = resizeData.orientation;
        if(!this._logo) {
            return;
        }
        this.setLogoScale();

        if(this._orientation === Orientation.LANDSCAPE) {
            this.setLogoPosition();
            this._logo.visible = true;
        }

        if(this._orientation === Orientation.PORTRAIT) {
            this._logo.visible = false;
        }
    }

    private onGameData(data:FruitsParsedGameData | FruitsParsedInitData):void {
        this._gameMode = data.mode;
        this._nextMode = data.nextMode;

        if (this._logo) {
            this._logo.visible = this._orientation !== Orientation.PORTRAIT;
        }

        if(!this._initDataReceived) {
            this._initDataReceived = true;
            this.createGraphics();
        }
    }

    private setLogoScale():void {
        if(this._currentLogo.name === "normal") {
            this._logo.scale.set(0.5, 0.5);
        } else {
            this._logo.scale.set(1, 1);
        }
    }

    private setLogoPosition():void {
        if(this._currentLogo.name === "bonus") {
            this._logo.position.set(950, 80);
        } else {
            this._logo.position.set(280, 80);
        }
    }

    private createGraphics() {
        if(!this._initDataReceived || !this._gfxLoaded) {
            return;
        }

        this.setCurrentLogo(this._gameMode);
        this._logo = new PIXI.Sprite(GameResources.getTextures(this._currentLogo.textureName)[0]);
        this._logo.anchor.set(0.5, 0.5);
        this.setLogoPosition();
        this.setLogoScale();
        this._logo.visible = this._orientation !== Orientation.PORTRAIT;
        this._container.addChild(this._logo);
    }

    public changeLogo(newMode:string):void {
        if(newMode === this._gameMode)
            return;

        const tl:TimelineLite = new TimelineLite();
        let revealInterval:string = newMode === FruitsGameMode.BONUS_GAME ? "+= 1.1" : "+= .2";

        tl.add(TweenLite.to(this._logo, 0.2, {alpha : 0}));
        tl.add(() => {
            this.setCurrentLogo(newMode);
            this.changeLogoTexture(this._currentLogo.textureName);
            this._gameMode = newMode;

            this.setLogoPosition();
            this.setLogoScale();
        });
        tl.add(TweenLite.to(this._logo, 0.2, {alpha : 1}), revealInterval);
    }

    private setCurrentLogo(newMode:string):void {
        this._logos.forEach((logo) => {
            if(logo.mode === newMode)
                this._currentLogo = logo;
        });

    }

    private changeLogoTexture(textureName:string):void {
        this._logo.texture = GameResources.getTextures(textureName)[0];
    }

}